import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { THANK, ENDTEXT } from "../Utils/static-strings";

const ThankYou = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.header}>{THANK}</Text>
      <Text style={styles.body}>{ENDTEXT}</Text>
    </View>
  );
};

export default ThankYou;

const styles = StyleSheet.create({
  container: {
    minHeight: "100vh",
    width: "100vw",
    backgroundColor: "#f5f5f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: 24,
  },
  header: {
    fontFamily: "Infra",
    fontSize: 28,
    fontWeight: "700",
    color: "#2f2f2f",
    marginBottom: 12,
  },
  body: {
    fontFamily: "Infra",
    fontSize: 18,
    color: "#2f2f2f",
    textAlign: "center",
    maxWidth: 520,
    lineHeight: 26,
  },
});
